import { render, staticRenderFns } from "./collectsCard.vue?vue&type=template&id=3a2b7ead&scoped=true"
import script from "./collectsCard.vue?vue&type=script&lang=js"
export * from "./collectsCard.vue?vue&type=script&lang=js"
import style0 from "./collectsCard.vue?vue&type=style&index=0&id=3a2b7ead&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b7ead",
  null
  
)

export default component.exports